import { render } from "./InactiveScreen.vue?vue&type=template&id=080e5539&scoped=true"
import script from "./InactiveScreen.vue?vue&type=script&lang=js"
export * from "./InactiveScreen.vue?vue&type=script&lang=js"

import "./InactiveScreen.vue?vue&type=style&index=0&id=080e5539&scoped=true&lang=css"

import exportComponent from "/Users/peterdevos/Sites/bcfcareer25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080e5539"]])

export default __exports__